// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__IgJV6","link":"Menu_link__ZzzJQ","menu_title":"Menu_menu_title__j-Ga+"};